/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Sensor
 */
export interface Sensor {
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    value: string;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    unit: string;
    /**
     * 
     * @type {string}
     * @memberof Sensor
     */
    status: string;
}

export function SensorFromJSON(json: any): Sensor {
    return SensorFromJSONTyped(json, false);
}

export function SensorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Sensor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
        'unit': json['unit'],
        'status': json['status'],
    };
}

export function SensorToJSON(value?: Sensor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'value': value.value,
        'unit': value.unit,
        'status': value.status,
    };
}


